import ApiConnector from "@/repository/connector";

class Auth {
  login = async ({ username, password }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.post(`/api/token/`, {
      username,
      password,
    });
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  logout =  async ({id }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.post(`/api/supervisions/${id}/finish/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
}

export default new Auth()